import React from 'react'
import Image from './Image'

export default class Carousel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.id = `carousel-${Date.now()}`
    this.maxWidth = 1024
    this.setup = this.setup.bind(this)
  }
  componentDidMount() {
    this.setup()
    window.addEventListener('resize', this.setup)
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.setup)
  }
  setup() {
    if (typeof(this.container)==='object') {
      const width = this.container.offsetWidth
      if (typeof(width)==='number'&&width>0) {
        this.setState({width:width})
      }
    }
  }
  render() {
    return (
      <div
        id={this.id}
        className="carousel slide"
        data-ride="carousel"
        ref={el=>{this.container=el}}
      >
        <ol className="carousel-indicators">
          {
            Array.isArray(this.props.images)&&
            this.props.images.length>0&&
            this.props.images.map((src,i)=>(
              <li key={i} data-target={`#${this.id}`} data-slide-to="0" className={`${i===0?'active':''}`}></li>
            ))
          }
        </ol>
        <div className="carousel-inner">
          {
            Array.isArray(this.props.images)&&
            this.props.images.length>0&&
            this.props.images.map((image,i)=>(
              <div key={i} className={`carousel-item ${i===0?'active':''}`}>
                <Image
                  {...image}
                  viewMode="full"
                  maxWidth={this.state.width||this.maxWidth}
                />
              </div>
            ))
          }
        </div>
        <a className="carousel-control-prev" href={`#${this.id}`} role="button" data-slide="prev">
          <span className="carousel-control-prev-icon" aria-hidden="true"></span>
          <span className="sr-only">Previous</span>
        </a>
        <a className="carousel-control-next" href={`#${this.id}`} role="button" data-slide="next">
          <span className="carousel-control-next-icon" aria-hidden="true"></span>
          <span className="sr-only">Next</span>
        </a>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageCarousel.js